var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.84998 8.33335H3.84998M9.24997 8.33334L12.85 21.4C13.1505 22.4304 13.7745 23.3368 14.63 23.9851C15.4854 24.6334 16.5267 24.9893 17.6 25H32.1666V8.33334H9.24997ZM20.5166 30.8333C20.5166 32.2141 19.3974 33.3333 18.0166 33.3333C16.6359 33.3333 15.5166 32.2141 15.5166 30.8333C15.5166 29.4526 16.6359 28.3333 18.0166 28.3333C19.3974 28.3333 20.5166 29.4526 20.5166 30.8333ZM32.1833 30.8333C32.1833 32.2141 31.064 33.3333 29.6833 33.3333C28.3026 33.3333 27.1833 32.2141 27.1833 30.8333C27.1833 29.4526 28.3026 28.3333 29.6833 28.3333C31.064 28.3333 32.1833 29.4526 32.1833 30.8333Z",
    stroke: "#1C1C1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.4f84966112e2e2df7f7286597b19eeab.svg";
export { ForwardRef as ReactComponent };